import { Icon, Input } from "semantic-ui-react";
import CloseDetailPage from "../../components/CloseComponent/CloseDetailPage";
import { IoCloseOutline } from "react-icons/io5";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import CommonOpacityBackground from "../../components/Common/commonOpacityBackground";
import { useMemo, useState } from "react";
import { COMMON_WEB_PATH } from "../../constant";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import useSubTypeList from "../../hook/useSubTypeList";
import useSpecPath from "../../hook/useSpecPath";
import useCasinoType from "../../hook/useCasinoType";
import { filterType } from "../../hook/useGameListFilter";
import { BsTools } from "react-icons/bs";
import LazyImage from "../../components/Loading/lazyImage";

const CasinoGroups = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const [search, setSearch] = useState("");

  const navigate = useNavigate();

  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);

  const casinoType = useCasinoType();

  const {
    allGamePlatform = [],
    sortedByPlatformGames = {},
    sortedByPlatformAndCategoryGames = {},
  } = isHandleAllGame;

  const subTypeList = useSubTypeList({ forceShowAll: true });

  const filterPlatformBySubType = useMemo(() => {
    const filterNullGame = Object.keys(sortedByPlatformAndCategoryGames).filter(
      (key) =>
        Object.keys(sortedByPlatformAndCategoryGames[key]).some((k) =>
          subTypeList.includes(k)
        )
    );
    const list = filterNullGame.map((item) => {
      const listLengthBigThanOne =
        filterType({
          gameList: sortedByPlatformGames[item],
          casinoType: casinoType,
        })?.length > 0;

      if (!listLengthBigThanOne) {
        return;
      } else {
        return item;
      }
      // return item;
    });

    return list;
  }, [subTypeList]);

  const handleInput = (e) => {
    setSearch(e.target.value);
  };

  const casinoGroup = useMemo(() => {
    if (search) {
      return filterPlatformBySubType.filter((item) => {
        return item?.toLowerCase()?.includes(search);
      });
    } else {
      return filterPlatformBySubType;
    }
  }, [search, filterPlatformBySubType]);

  return (
    <CommonOpacityBackground path={-1}>
      <motion.div
        onClick={(e) => {
          e.stopPropagation();
        }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
        className="md:min-h-[248px] md:max-h[calc(100vh-92px)] w-full h-full bg-base-light-white overflow-y-scroll no-scrollbar dark:bg-base-dark md:w-[720px] md:rounded-[10px] flex flex-col gap-[30px] px-[20px]"
      >
        <CloseDetailPage
          title={`${i18n(casinoType)} ${i18n("Providers")}`}
          customClose={
            <IoCloseOutline
              className="cursor-pointer md:block hidden"
              onClick={() => {
                navigate(-1);
              }}
            />
          }
        />
        <section>
          <Input
            size="large"
            className="w-full"
            iconPosition="left"
            icon
            placeholder={i18n("Search")}
          >
            <input
              onChange={(e) => {
                handleInput(e);
              }}
              className="!bg-transaction-card dark:!bg-base-light-dark !text-base-light-dark dark:!text-base-light-white"
            />
            <Icon className="!text-light-text" name="search" />
          </Input>
        </section>
        <section className="grid grid-cols-2 md:grid-cols-4 gap-[20px]">
          {!search && (
            <div
              onClick={() => {
                navigate(`/${casinoType}`);
              }}
              className={`bg-base-white dark:bg-base-light-dark hover:border-main-color cursor-pointer h-[56px] rounded-[7px] py-[18px] px-[7px] flex items-center justify-center hover:bg-hover-transaction-card`}
            >
              <p className="underline dark:text-base-light-white text-base-light-dark">
                {i18n("All providers")}
              </p>
            </div>
          )}
          {casinoGroup?.map((plat, index) => {
            const platConfig = allGamePlatform?.find(
              (item) => item.platform === plat
            );
            const isMaintain = platConfig?.isUnderMaintenance === true;

            return (
              plat && (
                <div
                  onClick={() => {
                    if (isMaintain) {
                      return;
                    }
                    navigate(`/${casinoType}/category/${plat}/AllGames`);
                  }}
                  className={`bg-base-white dark:bg-base-light-dark relative overflow-hidden hover:border-main-color text-white cursor-pointer h-[56px] rounded-[7px] py-[18px] px-[7px] flex items-center justify-center hover:bg-hover-transaction-card`}
                >
                  {isMaintain && (
                    <div className="z-[2] absolute bg-[rgb(0,0,0,0.7)] top-0 left-0 w-full h-full flex flex-col items-center justify-center">
                      <BsTools className="text-2xl" />

                      <span className="text-xs tracking-tighter">
                        {platConfig?.maintenanceStartTime || "-"} ~
                      </span>
                      <span className="text-xs tracking-tighter">
                        {platConfig?.maintenanceEndTime || "-"}
                      </span>
                    </div>
                  )}

                  <LazyImage
                    className="w-[100px] h-[55px] object-contain"
                    src={`${COMMON_WEB_PATH}/platformIcon/${plat}.png`}
                    alt={plat}
                  />
                </div>
              )
            );
          })}
        </section>
      </motion.div>
    </CommonOpacityBackground>
  );
};

export default CasinoGroups;
